// extracted by mini-css-extract-plugin
export default {"form":"ManagerForm_form__J2GcX","formLabel":"ManagerForm_formLabel__YMHc2","input":"ManagerForm_input__ZNeaw","fieldInfo":"ManagerForm_fieldInfo__FPurA"};